import { connect, FormikValues } from 'formik'
import { cloneDeep, isEmpty } from 'lodash'
import { IntlShape } from 'react-intl'
import styled from 'styled-components'
import { object, string } from 'yup'

import FileUpload from '@/components/GenericForm/FileUpload'
import Label from '@/components/Label'
import { Row } from '@/components/StyledComponents'
import RadioGroup from '@/components/TailwindUI/RadioGroup'
import Toggle from '@/components/TailwindUI/Toggle'
import VariableInput from '@/pages/SpaceAppBuilder/components/VariableInput/VariableInput'
import { useWorkflowFeature } from '@/pages/SpaceAppBuilder/FeaturesPage/WorkflowFeatureContext'
import convertJSONtoSchema from '@/pages/SpaceAppBuilder/utilities/convertJSONToSchema'
import { FileUploadData, FileUploadMode, StepData } from '@/pages/SpaceAppBuilder/utilities/interfaces'

//<editor-fold desc="Styled Components">
const StyledRow = styled(Row)`
  justify-content: flex-start;
  margin-bottom: 5px;
`
//</editor-fold>

//<editor-fold desc="Interfaces">
interface FileUploadProps {
  readOnly: boolean
}

//</editor-fold>
const getValidationSchema = (_intl: IntlShape, formObject: any) => {
  const result: any = {
    uploadMode: string().required()
  }
  if (formObject.uploadMode === FileUploadMode.DIRECTORY) {
    result.attachment = object().shape({
      name: string().required('An attachment is required.')
    })
  } else {
    result.url = string().required('Url is required')
  }

  return result
}

const getNetworkRequestObject = (data: { triggerData: any; stepData: any }) => {
  const updatedValues: any = cloneDeep(data)
  const { stepData } = data
  if (isEmpty(stepData)) return data

  //used to define variables for the step
  if (stepData.attachment) {
    updatedValues.output = convertJSONtoSchema(stepData.attachment)
  } else {
    updatedValues.output = convertJSONtoSchema({
      url: 'http://workgridassets.com'
    })
  }

  return updatedValues
}

const getInitialValues = (stepData: FileUploadData): StepData => ({
  attachment: stepData.attachment,
  uploadMode: stepData.uploadMode ?? FileUploadMode.DIRECTORY,
  url: stepData.url,
  expire: stepData.expire ?? true
})

const FileUploadOperation = ({ formik, readOnly }: FileUploadProps & FormikValues) => {
  const { getVariablesForStep } = useWorkflowFeature()
  const variables = getVariablesForStep()
  const { setFieldValue, values } = formik
  const uploadMode = values.stepData.uploadMode
  const expire = values.stepData.expire ?? true
  const uploadModes = [FileUploadMode.DIRECTORY, FileUploadMode.URL]
  return (
    <div data-testid="user-lookup-property-panel">
      <StyledRow>
        <Label required>Upload a document.</Label>
      </StyledRow>
      <RadioGroup
        name="uploadMode"
        value={uploadMode}
        options={uploadModes}
        onChange={value => setFieldValue('stepData.uploadMode', value)}
        disabled={readOnly}
        className="mt-2 px-1"
      />
      {uploadMode === FileUploadMode.DIRECTORY ? (
        <FileUpload
          className="mt-4"
          disabled={readOnly}
          formatProps={{ name: `stepData.attachment` }}
          onChange={value => {
            setFieldValue('stepData.attachment', value)
          }}
          value={values.stepData.attachment}
        />
      ) : (
        <VariableInput label="File Url" name="stepData.url" variables={variables} />
      )}
      <Toggle
        className="mt-4"
        label="Expire after 30 days"
        boldHeaders={true}
        checked={expire}
        onChange={value => setFieldValue('stepData.expire', value)}
      />
    </div>
  )
}

export default connect(FileUploadOperation)

export { getInitialValues, getValidationSchema, getNetworkRequestObject }
